import request from '../../../config/Request'

const basicApi = {
    carQueryList:'/api/car/queryList', //查询车辆信息列表
    carQueryDetail:'/api/car/queryDetail', //查询车辆信息详细
    carEditDetail:'/api/car/editDetail', //编辑车辆信息
    carDelDetail:'/api/car/delDetail', //删除车辆信息

    deviceQueryList:'/api/Device/queryList',// 查询设备信息列表
    deviceQueryDetail:'/api/Device/queryDetail',// 查询设备信息详细
    deviceEditDetail:'/api/Device/editDetail',// 编辑设备信息
    deviceDelDetail:'/api/Device/delDetail',// 删除设备信息

    boxQueryList:'/api/TurnoverBox/queryList',// 查询周转箱信息列表
    boxQueryDetail:'/api/TurnoverBox/queryDetail',// 查询周转箱信息详细
    boxEditDetail:'/api/TurnoverBox/editDetail',// 编辑周转箱信息
    boxDelDetail:'/api/TurnoverBox/delDetail',// 删除周转箱信息

    orgQueryList:'/api/Org/queryList',// 查询医疗机构信息列表
    orgQueryDetail:'/api/Org/queryDetail',// 查询医疗机构信息详细
    orgEditDetail:'/api/Org/editDetail',// 编辑医疗机构信息
    orgDelDetail:'/api/Org/delDetail',// 删除医疗机构信息
};
/**
 * 查询车辆信息列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function getCarQueryList(parameter) {
    return request({
        url: basicApi.carQueryList,
        data: parameter
    })
}
/**
 * 编辑车辆信息
 * @param parameter 编辑参数
 * @returns {AxiosPromise} 请求对象
 */
export function carEditDetail(parameter) {
    return request({
        url: basicApi.carEditDetail,
        data: parameter
    })
}
/**
 * 删除车辆信息
 * @param parameter 删除参数（车辆ID）
 * @returns {AxiosPromise} 请求对象
 */
export function carDelDetail(parameter) {
    return request({
        url: basicApi.carDelDetail,
        data: parameter
    })
}
/**
 * 查询设备信息列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function getDeviceQueryList(parameter) {
    return request({
        url: basicApi.deviceQueryList,
        data: parameter
    })
}
/**
 * 编辑设备信息
 * @param parameter 编辑参数
 * @returns {AxiosPromise} 请求对象
 */
export function deviceEditDetail(parameter) {
    return request({
        url: basicApi.deviceEditDetail,
        data: parameter
    })
}
/**
 * 删除设备信息
 * @param parameter 删除参数（设备ID）
 * @returns {AxiosPromise} 请求对象
 */
export function deviceDelDetail(parameter) {
    return request({
        url: basicApi.deviceDelDetail,
        data: parameter
    })
}
/**
 * 查询周转箱信息列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function getBoxQueryList(parameter) {
    return request({
        url: basicApi.boxQueryList,
        data: parameter
    })
}
/**
 * 编辑周转箱信息
 * @param parameter 编辑参数
 * @returns {AxiosPromise} 请求对象
 */
export function boxEditDetail(parameter) {
    return request({
        url: basicApi.boxEditDetail,
        data: parameter
    })
}
/**
 * 删除周转箱信息
 * @param parameter 删除参数（周转箱ID）
 * @returns {AxiosPromise} 请求对象
 */
export function boxDelDetail(parameter) {
    return request({
        url: basicApi.boxDelDetail,
        data: parameter
    })
}
/**
 * 查询医疗机构信息列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function getOrgQueryList(parameter) {
    return request({
        url: basicApi.orgQueryList,
        data: parameter
    })
}
/**
 * 编辑医疗机构信息
 * @param parameter 编辑参数
 * @returns {AxiosPromise} 请求对象
 */
export function orgEditDetail(parameter) {
    return request({
        url: basicApi.orgEditDetail,
        data: parameter
    })
}
/**
 * 删除医疗机构信息
 * @param parameter 删除参数（周转箱ID）
 * @returns {AxiosPromise} 请求对象
 */
export function orgDelDetail(parameter) {
    return request({
        url: basicApi.orgDelDetail,
        data: parameter
    })
}
